import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icon/ic_pass@2x.png'
import _imports_1 from '../../assets/icon/ic_notpass@2x.png'
import _imports_2 from '../../assets/icon/ic_shenhe@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-d3755270"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desc" }
const _hoisted_2 = { class: "desc_info" }
const _hoisted_3 = { class: "desc_info_title" }
const _hoisted_4 = {
  key: 0,
  class: "yellow"
}
const _hoisted_5 = {
  key: 1,
  class: "green"
}
const _hoisted_6 = {
  key: 2,
  class: "red"
}
const _hoisted_7 = {
  key: 3,
  class: "red"
}
const _hoisted_8 = { class: "desc_info_company" }
const _hoisted_9 = { class: "desc_info_box" }
const _hoisted_10 = { class: "desc_info_box_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "申请编号：", -1))
const _hoisted_12 = { class: "desc_info_box_item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "申请日期：", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc_info_box_item" }, [
  /*#__PURE__*/_createElementVNode("span", null, "申请类型："),
  /*#__PURE__*/_createElementVNode("span", null, "工序报废申请")
], -1))
const _hoisted_15 = { class: "desc_info_box_item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前工厂：", -1))
const _hoisted_17 = { class: "desc_info_box_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出库仓库：", -1))
const _hoisted_19 = { class: "desc_info_box_item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入库仓库：", -1))
const _hoisted_21 = { class: "desc_info_box_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报废原因：", -1))
const _hoisted_23 = { class: "desc_info_box_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "申请人：", -1))
const _hoisted_25 = { class: "desc_qd" }
const _hoisted_26 = { class: "desc_qd_header" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc_qd_header_x" }, null, -1))
const _hoisted_28 = { class: "rework_qd_item_i" }
const _hoisted_29 = { class: "black" }
const _hoisted_30 = { class: "black" }
const _hoisted_31 = { class: "rework_qd_item_i" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物料信息：", -1))
const _hoisted_33 = { class: "rework_qd_item_i" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "批次号：", -1))
const _hoisted_35 = { class: "rework_qd_item_i" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "生产工序：", -1))
const _hoisted_37 = { class: "desc_process" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc_process_title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desc_process_title_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "流程")
], -1))
const _hoisted_39 = { class: "desc_process_box" }
const _hoisted_40 = { class: "desc_process_content" }
const _hoisted_41 = { class: "item_left" }
const _hoisted_42 = {
  key: 0,
  class: "item_x"
}
const _hoisted_43 = { class: "item_left_img" }
const _hoisted_44 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_45 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_46 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_47 = { class: "item_left_text" }
const _hoisted_48 = {
  key: 0,
  class: "item_left_text_info"
}
const _hoisted_49 = { class: "item_right" }

import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"
import { Toast } from 'vant'

import { getsqdInfo } from '@/apis/WorkOrderAPI'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const route = useRoute()
const store = useStore()

// 报废清单
let data = ref<object>({})
let detailList = ref<Array<any>>([])

onMounted(() => {
  getInfo(route.query.id as string)
})

const getInfo = async (id: string | number): Promise<void> => {
  let res = await getsqdInfo(id)
  if (res.code === 200) {
    data.value = res.data
    detailList.value = res.data.detailList
  } else {
    Toast.fail({ message: res.message })
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(data).title), 1),
        (_unref(data).status === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "待审核"))
          : (_unref(data).status === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "审批通过"))
            : (_unref(data).status === 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "审批未通过"))
              : (_unref(data).status === 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "审批终止"))
                : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(store).state.userInfo.rootDepartment.name), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_unref(data).code), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString(_unref(data).createTime), 1)
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", null, _toDisplayString(_unref(data).factoryName), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("span", null, _toDisplayString(_unref(data).warehouseOutName), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("span", null, _toDisplayString(_unref(data).warehouseName), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("span", null, _toDisplayString(_unref(data).content), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("span", null, _toDisplayString(_unref(data).createUserName) + " / " + _toDisplayString(_unref(data).departmentName), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("span", null, "报废工装清单(" + _toDisplayString(_unref(detailList).length) + ")", 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).detailList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "desc_qd_info",
          key: index
        }, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, "工装信息：" + _toDisplayString(item.applianceCode ? item.applianceCode : '-') + " / ", 1),
            _createElementVNode("span", _hoisted_30, _toDisplayString(item.num + item.unitName), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("span", null, _toDisplayString(item.materialName + ' | ' + item.materialCode), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("span", null, _toDisplayString(item.batch ?? '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("span", null, _toDisplayString(item.procedureName), 1)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_37, [
      _hoisted_38,
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).recordList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_41, [
                (_unref(data).recordList.length - 1 !== index)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("p", null, _toDisplayString(item.userModel ? item.userModel.name.substr(0, 1) : '-'), 1),
                  (item.operationResult === 'AGREE')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                    : (item.operationResult === 'REFUSE')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_45))
                      : (item.operationResult === 'NONE')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_46))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", null, _toDisplayString(index === 0 ? '发起申请' : '审批人'), 1),
                  _createElementVNode("span", null, _toDisplayString(item.userModel ? item.userModel.name : '-'), 1),
                  (item.remark)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("span", null, _toDisplayString(item.remark), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, _toDisplayString(item.date), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})